import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/image/icons/sidebar_mobile.svg'
import _imports_1 from '@/assets/image/logo/trust_fund_title.svg'


const _hoisted_1 = { class: "header-mobile-view" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = {
  key: 0,
  class: "login-btn"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 로그인 ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "login-btn respect" }, " 님", -1)
const _hoisted_7 = { class: "mobile-sidebar-area" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "userinfo-menu-item pointer-hover",
  onclick: "\n              location.href='https://trustfund.co.kr/increaseLimit';\n            \n          "
}, " 투자한도 늘리기 ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "logout" }, "로그아웃", -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_nav_bar_mobile = _resolveComponent("nav-bar-mobile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "sidebar",
          class: "sidebar-btn pointer-hover",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
        }),
        _createElementVNode("img", {
          src: _imports_1,
          alt: "title",
          class: "header-logo pointer-hover",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebarRouter('home')))
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.useIsLogin === false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_router_link, { to: { name: 'login' } }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "login-btn logged-in pointer-hover",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleUserMenu && _ctx.toggleUserMenu(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.userName) + " ", 1),
              _hoisted_6,
              _createElementVNode("div", {
                class: _normalizeClass(
            !_ctx.userMenuOpen
              ? 'arrow-btn pointer-hover'
              : 'arrow-btn pointer-hover selected'
          )
              }, null, 2)
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isOpen ? 'open-sidebar' : 'close-sidebar')
      }, [
        _createVNode(_component_nav_bar_mobile, {
          onWheel: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
          onTouchmove: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
          onScroll: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
        })
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(!_ctx.userMenuOpen ? 'display-none' : 'userinfo-menu'),
        onWheel: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
        onTouchmove: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"])),
        onScroll: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", {
          class: "userinfo-menu-item pointer-hover",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sidebarRouter('ivmtStatus')))
        }, " 마이라운지 "),
        _createElementVNode("div", {
          class: "userinfo-menu-item pointer-hover",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sidebarRouter('userinfo')))
        }, " 회원정보 "),
        _hoisted_8,
        _createElementVNode("div", {
          class: "logout-section pointer-hover",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.mobileLogout && _ctx.mobileLogout(...args)))
        }, _hoisted_10)
      ], 34)
    ])
  ], 64))
}